import { Product } from 'model'
import { GetStaticProps, InferGetStaticPropsType, GetStaticPaths } from 'next'
import { Page } from 'core/components'
import { useRouter } from 'next/router'
import { fetchStaticPropsData } from 'helpers/sanity'
import { CreateSellRequest, ProductSeo } from 'components'
import { getSanityClient, PRODUCT_FIELDS } from '@resellam/sanity'
import { fetch, filter, slice } from '@aonawale/sanity-query'

export const getStaticPaths: GetStaticPaths = async () => {
  const products = await fetch<Product[]>(
    getSanityClient(),
    {
      constraints: [
        filter('_type', '==', 'product'),
        filter('featured', '==', true),
      ],
    },
    `
      'id': _id,
      'slug': slug.current
    `,
  )
  const paths = products.map((product) => ({
    params: { product: product.slug },
  }))
  return {
    paths,
    fallback: true,
  }
}

export const getStaticProps: GetStaticProps<{ product: Product }> = (context) =>
  fetchStaticPropsData(
    'product',
    {
      constraints: [
        filter('_type', '==', 'product'),
        filter('slug.current', '==', context.params?.product),
        slice(0),
      ],
    },
    PRODUCT_FIELDS,
  )

const SellPage = ({
  product,
}: InferGetStaticPropsType<typeof getStaticProps>) => {
  const router = useRouter()
  const loading = router.isFallback

  return (
    <Page loading={loading} title={`Sell ${product?.title ?? ''}`}>
      {product && (
        <ProductSeo
          product={product}
          title={`Sell ${product.title}`}
          path={`/sell/${product.slug}`}
        />
      )}
      <CreateSellRequest type="sell" product={product} loading={loading} />
    </Page>
  )
}

export default SellPage
